var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItsmarcosjreyesHeaderSmallKineticappengineLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "630px",
    height: "630px",
    viewBox: "0 0 630 630",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "itsmarcosjreyes-header-small-kineticappengine-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "itsmarcosjreyes-header-small-kineticappengine-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cogwheel,-gear,-mechanism,-l",
    transform: "translate(72.000000, 65.000000)",
    stroke: "#FF5B00",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 244,
    cy: 250,
    r: 107
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 243.5,
    cy: 250.5,
    r: 53.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.351487,249.99375 C421.351487,242.175 420.677285,234.53125 419.70968,226.975 L485.993757,189.71875 L474.950573,155.76875 L399.645918,164.59375 C392.229692,150.9875 382.984381,138.55625 372.440605,127.3875 L404.196784,58.24375 L375.324693,37.25 L319.453296,88.84375 C305.725787,82.29375 291.105585,77.425 275.736269,74.5625 L260.822664,0 L225.158609,0 L210.251246,74.5625 C194.875687,77.425 180.255485,82.3125 166.527976,88.84375 L110.656579,37.25 L81.7907311,58.225 L113.54691,127.3875 C102.978164,138.5625 93.7390947,150.9875 86.3291116,164.59375 L11.0119714,155.76875 L0,189.71875 L66.2840775,226.975 C65.3102297,234.53125 64.6297847,242.175 64.6297847,249.99375 C64.6297847,257.80625 65.2915018,265.46875 66.2840775,273.00625 L0,310.2625 L11.0119714,344.24375 L86.3291116,335.39375 C93.7453373,348.99375 102.984406,361.45 113.54691,372.59375 L81.7907311,441.75 L110.656579,462.75 L166.527976,411.13125 C180.255485,417.6875 194.888172,422.56875 210.263731,425.4375 L225.158609,500 L260.822664,500 L275.723784,425.4375 C291.111828,422.56875 305.73203,417.6875 319.465781,411.13125 L375.330936,462.75 L404.203026,441.7375 L372.446848,372.59375 C382.990623,361.425 392.242177,348.99375 399.652161,335.39375 L474.956815,344.24375 L486,310.2625 L419.715923,273.00625 C420.677285,265.44375 421.351487,257.8 421.351487,249.99375 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItsmarcosjreyesHeaderSmallKineticappengineLogo);
export default __webpack_public_path__ + "static/media/itsmarcosjreyes-header-small-kineticappengine-logo.caa095aaa83fe6c33cd8c9ae9b6fe20b.svg";
export { ForwardRef as ReactComponent };